<!-- Sidemenu -->
<template>
	<div class="col-12 col-md-3 col-lg-2 sidemenu">
		<ul class="list">
			<li><a @click="goToHome"><i class="far fa-newspaper"></i> Newsfeed</a></li>
			<li><a @click="goToPhotos"><i class="far fa-image"></i> Photos</a></li>
			<li><a @click="goToNotification"><i class="far fa-bell"></i> Notifications</a></li>
			<li @click="goToMessage"><a href="#"><i class="far fa-envelope"></i> Messages</a></li>
		</ul>
	</div>
</template>
<!-- End of Sidemenu -->

<script>
	export default {
		methods: {	
			goToMessage() {
				this.$router.push({name: 'message'});
			},
			goToPhotos() {
				this.$router.push({name: 'profile', params: { type: 'photos-videos' }});
			},
			goToNotification() {
				this.$router.push({name: 'notification'});
			},
			goToHome() {
				this.$router.push({name: 'home'});
			},
		}
	}
</script>